export function initShare() {

  document.querySelectorAll('.section__share').forEach(el => {

    const url = el.dataset.url || window.location.href;
    const title = el.dataset.title || document.title;

    const targets = {
      facebook: u => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}`,
      twitter:  (u, t) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(u)}&text=${encodeURIComponent(t)}`,
      linkedin: u => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(u)}`,
      whatsapp: (u, t) => `https://api.whatsapp.com/send?text=${encodeURIComponent(t + ' ' + u)}`
    };

    el.querySelectorAll('[data-share]').forEach(btn => {

      btn.addEventListener('click', async (e) => {

        e.preventDefault();
        const type = btn.dataset.share;

        if (type === 'copy') {

          try {
            await navigator.clipboard.writeText(url);
          } catch (err) {
            const tmp = document.createElement('textarea');
            tmp.value = url;
            document.body.appendChild(tmp);
            tmp.select();
            document.execCommand('copy');
            document.body.removeChild(tmp);
          }

          el.classList.add('_copied');
          clearTimeout(el._copyTimer);
          el._copyTimer = setTimeout(() => el.classList.remove('_copied'), 2000);
          return;

        }

        const buildUrl = targets[type];
        if (!buildUrl) return;

        window.open(buildUrl(url, title), '_blank', 'width=600,height=500,noopener,noreferrer');

      });

    });

  });

}
